import { Elements, IContentItem } from '@kontent-ai/delivery-sdk';

export const checkHasCta = <T extends { cta: Elements.RichTextElement }>(
  cmsData: IContentItem<T>,
): boolean => cmsData.elements.cta.linkedItems.length > 0;
